
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"86","height":"74","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.502 33.779c7.743 0 14.02-7.338 14.02-16.39C44.522 8.338 38.245 1 30.502 1c-7.744 0-14.02 7.338-14.02 16.39 0 9.051 6.276 16.389 14.02 16.389zM22.286 36.66s-1.931 4.818-8.707 4.818c0 0-12.569.968-12.569 19.283M47.424 41.478c-6.765 0-8.696-4.817-8.696-4.817M67.338 46.018c7.743 0 14.02-7.338 14.02-16.39 0-9.051-6.277-16.389-14.02-16.389-7.743 0-14.02 7.338-14.02 16.39 0 9.051 6.277 16.39 14.02 16.39zM59.122 48.9s-1.931 4.818-8.707 4.818c0 0-12.569.968-12.569 19.282M84.26 53.718c-6.764 0-8.696-4.818-8.696-4.818","stroke":"#333","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    